import React, { useEffect, useRef } from 'react';
import cytoscape from 'cytoscape';
import fcose from 'cytoscape-fcose';

cytoscape.use(fcose);

// 模拟外部边捆绑算法的返回结果（路径点数组）
const bundledPaths = {
    'a-b': [
        [100, 100],
        [130, 120],
        [160, 140],
        [190, 160],
    ],
    'a-c': [
        [100, 100],
        [120, 80],
        [140, 60],
        [160, 50],
    ],
};

const BundledCompoundGraph = () => {
    const cyRef = useRef(null);

    useEffect(() => {
        const cy = cytoscape({
            container: cyRef.current,
            elements: [
                // Compound parent node
                { data: { id: 'parent', label: 'Group A' } },
                // Nodes inside parent
                { data: { id: 'a', label: 'Node A1', parent: 'parent' } },
                { data: { id: 'b', label: 'Node A2', parent: 'parent' } },
                // External node
                { data: { id: 'c', label: 'Node B' } },
                // Edges
                { data: { id: 'a-b', source: 'a', target: 'b' } },
                { data: { id: 'a-c', source: 'a', target: 'c' } },
            ],
            style: [
                {
                    selector: 'node',
                    style: {
                        label: 'data(label)',
                        'background-color': '#61bffc',
                        'text-valign': 'center',
                        'text-halign': 'center',
                        padding: 10,
                    },
                },
                {
                    selector: '$node > node', // compound parent node
                    style: {
                        'background-color': '#ccc',
                        'border-color': '#000',
                        'border-width': 2,
                        label: 'data(label)',
                        'text-valign': 'top',
                        'text-halign': 'center',
                        padding: 20,
                    },
                },
                {
                    selector: 'edge',
                    style: {
                        width: 2,
                        'line-color': '#999',
                        'curve-style': 'segments', // 关键
                        // 'target-arrow-shape': 'triangle',
                        // 'target-arrow-color': '#999',
                    },
                },
            ],
            layout: {
                name: 'fcose',
                animate: false,
                nodeSeparation: 100,
            },
        });

        // 应用自定义捆绑路径（仅中间点）
        cy.ready(() => {
            cy.edges().forEach(edge => {
                const id = edge.id(); // e.g. 'a-b'
                const path = bundledPaths[id];

                if (path && path.length > 2) {
                    // 去掉 source 和 target 端点，只保留中间控制点
                    const controlPoints = path.slice(1, -1).map(([x, y]) => ({ x, y }));

                    edge.style({
                        'curve-style': 'segments',
                        'control-point-positions': controlPoints,
                    });
                }
            });
        });

        return () => cy.destroy();
    }, []);

    return <div ref={cyRef} style={{ width: '800px', height: '500px' }} />;
};

export default BundledCompoundGraph;
